import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portal from "@/components/Portal";
import SyamPortal from "@/components/SyamPortal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portal />} />
          <Route path="/syam" element={<SyamPortal />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
